import React, { useEffect, useState } from "react"
import {
  getClientDetails,
  getCustomersFixedVoice
} from "services/state/fixedVoice/action"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { ensureArray } from "services/utils/validation"
import _, { get } from "lodash"
import TableFixedVoice from "../Inputs/TableFixedVoice"
import styles from "./styles.css"
import { headerClients, optionsActions } from "./constants"

const convertRecord = (records) => {
  return _.map(records, (value, key) => {
    return {
      name: get(value, "NOME", ""),
      document: get(value, "CPF/CNPJ", ""),
      type: get(value, "ESTADO", ""),
      city: get(value, "CIDADE", ""),
      status: get(value, "STATUS", ""),
      numbers: get(value, "NUMEROS", "")
    }
  })
}

const MyCustomers = ({
  customers,
  circuit,
  loading,
  redirectClientDetails,
  getCustomersFixedVoice,
  getClientDetails,
  isLimitAchieved
}) => {
  const [currentPage, setCurrentPage] = useState(1)
  const recordObject = get(customers, "records", [])
  const totalPages = get(customers, "totalPage", 1)
  const records = convertRecord(ensureArray(recordObject))

  const onSelectClient = (customerSelected) => {
    getClientDetails(customerSelected)
    redirectClientDetails()
  }

  const onActionSearch = (nameSearch) => {
    getCustomersFixedVoice({ partnerDoc: nameSearch })
  }

  useEffect(() => {
    if (!loading && circuit) {
      getCustomersFixedVoice({ page: currentPage })
    }
  }, [currentPage, circuit])

  return (
    <div>
      <div className={styles.header_customer}>
        <h2>Meus clientes</h2>
      </div>

      <TableFixedVoice
        headers={headerClients}
        records={records}
        actions={optionsActions}
        type={"ASSET"}
        page={currentPage}
        changePage={setCurrentPage}
        totalPages={totalPages}
        loading={loading}
        selectClient={onSelectClient}
        searchPlaceholder={"Pesquisar por CPF/CNPJ"}
        search={onActionSearch}
        registrationNotAllowed={isLimitAchieved}
        isClientNumber
      />
    </div>
  )
}

MyCustomers.propTypes = {
  redirectClientDetails: PropTypes.func,
  customers: PropTypes.object,
  circuit: PropTypes.string,
  loading: PropTypes.bool,
  getClientDetails: PropTypes.func.isRequired,
  getCustomersFixedVoice: PropTypes.func.isRequired,
  isLimitAchieved: PropTypes.bool
}

const mapStateToProps = ({ newOrder, customersFixedVoice }) => ({
  customers: customersFixedVoice.customers,
  loading: customersFixedVoice.loadingNumbers,
  circuit: newOrder.circuit,
  isLimitAchieved: customersFixedVoice.isLimitAchieved
})

const mapActionsToProps = {
  getClientDetails,
  getCustomersFixedVoice
}

export default connect(mapStateToProps, mapActionsToProps)(MyCustomers)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/MyCustomers/index.js